import { axiosInstance } from "@/services/axiosInstance";

export const assignCorbanProcessor = async (
  corbanId: number
): Promise<void> => {
  try {
    await axiosInstance.post("/api/processor-corban/assign", {
      corbanId,
    });
  } catch (error) {
    console.error("Erro ao atribuir corban ao processor:", error);
    throw error;
  }
};
